<template>
  <section class="content checkout-content d-flex justify-content-center pt-0 wp_MarginBottomAllPage">
    <!-- <div class="container">
      <div class="row">
        <signup-banner>
        </signup-banner>
      </div>
    </div> -->
    <div class="clientauth-wrapper mt-5">
					<!--<signin-form @loginSuccess="redirectToCheckOutPage"/>-->
					<div class="col-12">
						<div class="form-signin">
							<h1 class="h3 mb-3 font-weight-normal" id="sign-in-form-head"
											data-test="SignInFormHeading">
								Login to your account
							</h1>
							<login-form :buttonText="'Login'"
																			@loginSuccess="redirectToCheckOutPage()"
							/>
							<hr>
							<p class="newuser">New Customer?
								<a href=""
											@click.prevent="register"
											data-test="SignInFormRegisterLink"
								>
									Register
								</a>
							</p>
							<p class="newuser" v-if="isBankTenant">
								Are You a Bank Customer?
								<a href=""
											@click.prevent="$router.push('/bank-login')"
											data-test="SignInFormRegisterLink"
											id="SignInFormRegisterLink"
								>
									Register
								</a>
							</p>
						</div>
					</div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { orderApi } from '@/services/ApiServices/orderApi'
import LoginForm from './forms/LoginForm'

export default {
	beforeMount () {
		if (this.isAuthenticated) {
			this.$router.push('/')
		}
	},
	data () {
		return {
			isBankTenant: false,
			product_id: '',
			order_status: ''
		}
	},
	components: {
		LoginForm
	},
	computed: {
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('order', ['getTotalOrderData']),
		...mapGetters('user', ['isAuthenticated'])
	},
	methods: {
		redirectToCheckOutPage () {
			for (let i = 0; i < this.getSelectedProduct.length; i += 1) {
				this.product_id = this.getSelectedProduct[i].product_id
			}
			//
			//
			//
			// for (let i = 0; i < this.getTotalOrderData.orderHistory.length; i += 1) {
			//
			//   for (let j = 0; j < this.getTotalOrderData.orderHistory[i].orderProductDetails.length; j += 1) {
			//
			//     this.order_status = this.getTotalOrderData.orderHistory[i].orderProductDetails[j].order_status;
			//     // if (this.order_status === 'Delivered') {
			//     //   if (this.product_id === this.getTotalOrderData.orderHistory[i].orderProductDetails[j].product_id) {
			//     //
			//     //   }
			//     // }
			//   }
			// }
			// if (this.$route.query.next_to === 'checkOut') {
			//   this.$router.push('/checkout');
			// } else
			if (this.$route.query.next_to === 'current') {

			} else if (this.$route.query.next_to === 'wishList') {
				// const productId = [];
				// productId.push(this.$route.query.product_id);
				//
				// productApi.getProductsByIds(productId)
				//   .then((res) => {
				//     if (res && res.data && res.data[0]) {
				//       this.addToWishlist(res.data[0]);
				//       customerApi.insertWishList().then(() => {
				this.$router.push({
					path: '/user/wish-list',
					query: {
						// next_to: 'user-wishlist',
						product_id: this.$route.query.product_id,
						display_text: 'My Wishlist'
					}
				})
			} else if (this.$route.query.next_to === 'checkOut') {
				this.$router.push({
					name: 'CheckoutPage'
				})
			} else if (this.$route.query.next_to === 'previous') {
				this.$router.go(-1)
			} else if (this.$route.query.next_to === 'orders') {
				this.$router.push({
					path: '/user/orders'
				})
			} else if (this.$route.query.next_to === 'user') {
				this.$router.push({
					path: '/user/account'
				})
			} else if (this.$route.query.next_to === 'GiftCard') {
				this.$router.push({
					path: '/user/giftCards',
					query: {
						display_text: 'Gift Cards'
					}
				})
			} else if (this.$route.query.next_to === 'cart') {
				this.$router.push({
					path: '/cart',
					query: {
						display_text: 'My Cart'
					}
				})
			} else if (this.$route.query.next_to === 'home') {
				this.$router.push({
					path: '/'
				})
			} else if (this.$route.query.next_to === 'orderRating') {
				orderApi.getOrderStatus(this.product_id)
					.then((res) => {
						if (res.data.delivered_status && res.data.is_ordered) {
							this.$router.push({
								path: '/user/orders/orderRating',
								query: {
									orderProductId: this.product_id,
									orderVendorId: ''
								}
							})
						} else if (res.data.delivered_status || res.data.is_ordered) {
							this.$router.push('/')
							this.$toasted.show('Only ordered, product haven\'t delivered yet')
						} else {
							this.$router.push('/')
							this.$toasted.show('Sorry! You are not allowed to review this product since you haven\'t bought it')
						}
					})
					.catch((e) => {

					})
			} else {
				this.$router.push('/')
			}
			// this.$router.push({ name: 'CheckoutPage' });
		},
		register () {
			let nextTo = 'home'
			if (this.$route.query && this.$route.query.next_to) {
				nextTo = this.$route.query.next_to
			}
			this.$router.push({
				path: '/signup',
				query: {
					next_to: nextTo
				}
			})
		}
	}
}
</script>
